/** Indicatorul de răspunsuri: o bară verde pentru fiecare ofertă primită. */
export function Meter({ sends }: { sends: { hasOffer: boolean }[] }) {
  return (
    <span className="meter" aria-hidden="true">
      {sends.map((s, i) => (
        <i key={i} className={s.hasOffer ? 'on' : ''} />
      ))}
    </span>
  );
}
